export default __webpack_public_path__ + "static/media/Gods Blessings - 35s sample.9661e88e.mp3";